'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var LOGGED_IN = exports.LOGGED_IN = 'loggedin';
var LOGGED_OUT = exports.LOGGED_OUT = 'loggedout';

var toLoginStatus = function toLoginStatus(authenticated) {
  return authenticated ? LOGGED_IN : LOGGED_OUT;
};

exports.default = function (state, props) {
  var authenticated = props.authenticated;
  var _props$emailCorrelati = props.emailCorrelationId;
  var emailCorrelationId = _props$emailCorrelati === undefined ? state.emailCorrelationId : _props$emailCorrelati;
  var _props$userClientId = props.userClientId;
  var userClientId = _props$userClientId === undefined ? state.userClientId : _props$userClientId;


  var loginStatus = typeof authenticated === 'undefined' ? state.loginStatus : toLoginStatus(authenticated);

  var userId = loginStatus === LOGGED_IN ? emailCorrelationId : userClientId;

  return _extends({}, state, {
    loginStatus: loginStatus,
    emailCorrelationId: emailCorrelationId,
    userClientId: userClientId,
    userId: userId
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/reducers/user.js
 ** module id = 441
 ** module chunks = 0
 **/